import request from '@/utils/request';

export const getAppWebsiteInfoPort = () => {
    return request({
        url: "/api/blade-platform/nobody/public/getAppWebsiteInfo",
        method: "get",
    });
};